import { render } from "./userServiceAgreementView.vue?vue&type=template&id=28441219&scoped=true"
import script from "./userServiceAgreementView.vue?vue&type=script&lang=js"
export * from "./userServiceAgreementView.vue?vue&type=script&lang=js"

import "./userServiceAgreementView.vue?vue&type=style&index=0&id=28441219&lang=less&scoped=true"

import exportComponent from "/Users/baojian/Documents/coipor/anyway-wx/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-28441219"]])

export default __exports__